"use strict";function detectFaceFullScreen$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.detectFaceFullScreen$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.ATMBle.detectFaceFullScreen";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.18"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.18"},_a)),exports.detectFaceFullScreen$=detectFaceFullScreen$,exports.default=detectFaceFullScreen$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/ATMBle/detectFaceFullScreen.js
// module id = 902
// module chunks = 106